import React from "react";
import {
  AdminPanelSidebarContainer,
  AdminPanesSidebarTitle, SidebarList, SidebarMenu,
  UserImage,
  UserInfo, UserStatus
} from "../../Style/Admin/AdminPanel";
import {NavLink} from "react-router-dom";
import {useDispatch} from "react-redux";
import {authorization, setToken} from "../../Redux/actions/authActions";

export const AdminModeratorSidebar = () => {
  const dispatch = useDispatch()


  const onExitHandler = () => {

    localStorage.removeItem('userData')
    dispatch(setToken(''))
    dispatch(authorization())
  }

  return(
    <AdminPanelSidebarContainer>
      <UserInfo>
        <UserImage><i className="far fa-user"/></UserImage>
      </UserInfo>
      <UserStatus>Ваш статус:</UserStatus>
      <AdminPanesSidebarTitle>Федеральный оператор</AdminPanesSidebarTitle>

      <SidebarMenu>
        <NavLink to={'/admin/users?p=1'}><SidebarList>Участники</SidebarList></NavLink>
        <NavLink to={'/admin/experts'}><SidebarList>Эксперты</SidebarList></NavLink>
        <NavLink to={'/admin/rating'}><SidebarList>Рейтинг</SidebarList></NavLink>
        <NavLink to={'/admin/registerExpert'}><SidebarList>Регистрация Эксперта</SidebarList></NavLink>
        <NavLink to={'/admin/registerUser'}><SidebarList>Регистрация Участника</SidebarList></NavLink>
        <NavLink to={'/'}>
          <SidebarList>Главная</SidebarList>
        </NavLink>
        <SidebarList onClick={() => onExitHandler()}>Выход</SidebarList>

      </SidebarMenu>

    </AdminPanelSidebarContainer>
  )
}